// What the screens need to know about laps already driven.

import { computed } from 'vue';
import { laps } from '../store.js';

export const CAR = 'Lamborghini Huracan';
export const TRACK = 'Marina Bay Street Circuit';

const finished = computed(() => laps.value.filter((l) => Number(l.timeMs) > 0));

/** The quickest finished lap, or null. */
export const bestLap = computed(() =>
  finished.value.reduce((best, l) => (!best || Number(l.timeMs) < Number(best.timeMs) ? l : best), null));

/** How many races ended in first place. */
export const wins = computed(() => finished.value.filter((l) => Number(l.place) === 1).length);

export const placeLabel = (n) => (Number(n) === 1 ? 'Winner' : `Finished P${n}`);
